<section class="corp-dashboard">
  <div class="category-row">
    <button
      type="button"
      *ngFor="let category of categories"
      class="category-btn"
      [class.active]="query.category === category"
      (click)="onCategoryChange(category)">
      {{ category | titlecase }}
    </button>
  </div>

  <ng-container *ngIf="countsLoading; else countsContent">
    <div class="counts-loader">
      <app-loading size="0.5" color="var(--primary-sec-color)"></app-loading>
    </div>
  </ng-container>

  <ng-template #countsContent>
    <div class="kpi-row">
      <button type="button" class="kpi-card kpi-card--total kpi-card--interactive" [class.active]="selectedQuickFilter === 'all'" (click)="onQuickFilterChange('all')">
        <p class="kpi-value">{{ kpiTotalValue }}</p>
        <p class="kpi-label">{{ totalCardLabel }}</p>
        <div *ngIf="showAllTotalDetails" class="kpi-total-split">
          <div class="kpi-total-split-head">
            <span class="kpi-total-split-head-label">Department</span>
            <span>Total</span>
            <span>Today</span>
            <span>ROs</span>
          </div>
          <div
            *ngFor="let detail of totalCardAllDetails"
            class="kpi-total-split-row"
            [ngClass]="{
              'kpi-total-split-row--service': detail.label === 'Service',
              'kpi-total-split-row--sales': detail.label === 'Sales',
              'kpi-total-split-row--parts': detail.label === 'Parts'
            }">
            <span class="kpi-total-split-label">{{ detail.label }}</span>
            <strong>{{ detail.total }}</strong>
            <strong>{{ detail.today }}</strong>
            <strong>{{ detail.ros }}</strong>
          </div>
        </div>
        <div *ngIf="showCategoryCardDetails" class="kpi-breakdown">
          <div *ngFor="let detail of totalCardDetails" class="kpi-type-row">
            <span>{{ detail.label }}</span>
            <strong>{{ detail.value }}</strong>
          </div>
        </div>
      </button>
      <button type="button" class="kpi-card kpi-card--interactive" [class.active]="selectedQuickFilter === 'today'" (click)="onQuickFilterChange('today')">
        <p class="kpi-value">{{ kpiTodayValue }}</p>
        <p class="kpi-label">TODAY'S APPTS</p>
      </button>
      <button type="button" class="kpi-card kpi-card--interactive" [class.active]="selectedQuickFilter === 'ros'" (click)="onQuickFilterChange('ros')">
        <p class="kpi-value">{{ kpiRosValue }}</p>
        <p class="kpi-label">ROS RECEIVED</p>
      </button>
      <button type="button" class="kpi-card kpi-card--pending kpi-card--interactive" [class.active]="selectedQuickFilter === 'pendingTestDrive'" (click)="onQuickFilterChange('pendingTestDrive')">
        <p class="kpi-value">{{ (dashboardCounts?.sales?.pendingTestDrive) ?? 0 }}</p>
        <p class="kpi-label">PENDING TEST DRIVE</p>
        <p class="kpi-sub">Link sent, not scheduled</p>
      </button>
      <button type="button" class="kpi-card kpi-card--pending kpi-card--interactive" [class.active]="selectedQuickFilter === 'pendingDelivery'" (click)="onQuickFilterChange('pendingDelivery')">
        <p class="kpi-value">{{ (dashboardCounts?.sales?.pendingDelivery) ?? 0 }}</p>
        <p class="kpi-label">PENDING DELIVERY</p>
        <p class="kpi-sub">Link sent, not scheduled</p>
      </button>
      <article class="kpi-card kpi-card--yesterday">
        <div class="kpi-yesterday-header">
          <p class="kpi-yesterday-title">Yesterday</p>
          <div class="kpi-yesterday-stats">
            <div class="kpi-yesterday-stat">
              <span class="kpi-yesterday-label">Appts:</span>
              <strong>{{ (dashboardCounts?.yesterdayCount?.totalAppointments) ?? 0 }}</strong>
            </div>
            <div class="kpi-yesterday-stat">
              <span class="kpi-yesterday-label">ROs:</span>
              <strong>{{ (dashboardCounts?.yesterdayCount?.roCount) ?? 0 }}</strong>
            </div>
            <div class="kpi-yesterday-stat">
              <span class="kpi-yesterday-label">NSH:</span>
              <strong>{{ (dashboardCounts?.yesterdayCount?.nsh) ?? 0 }}</strong>
            </div>
          </div>
        </div>
      </article>
    </div>
  </ng-template>

  <section class="filters">
    <div class="filter-group">
      <label for="vehicle">Vehicle</label>
      <select id="vehicle" [(ngModel)]="query.vehicle" (ngModelChange)="onFilterChange()">
        <option value="">All Vehicles</option>
        <option *ngFor="let vehicle of filters.vehicles" [value]="vehicle">{{ vehicle }}</option>
      </select>
    </div>

    <div class="filter-group">
      <label for="dealer">Dealer</label>
      <select id="dealer" [(ngModel)]="query.dealer" (ngModelChange)="onFilterChange()">
        <option value="">All Dealers</option>
        <option *ngFor="let dealer of filters.dealers" [value]="dealer">{{ dealer }}</option>
      </select>
    </div>

    <div class="filter-group">
      <label for="type">Type</label>
      <select id="type" [(ngModel)]="selectedType" (ngModelChange)="onTypeChange($event)">
        <option value="">All Types</option>
        <option *ngFor="let type of filters.types" [value]="type.value">{{ type.display }}</option>
      </select>
    </div>

    <div class="filter-group">
      <label for="source">Booking Source</label>
      <select id="source" [(ngModel)]="query.appointmentBookingSource" (ngModelChange)="onFilterChange()">
        <option value="">All Sources</option>
        <option *ngFor="let source of filters.sources" [value]="source.value">{{ source.display }}</option>
      </select>
    </div>

    <button type="button" class="clear-btn clear-btn--filters" (click)="clearFilters()">Clear</button>

    <div class="filter-group filter-group--page-size">
      <label for="pageSize">Records per page</label>
      <mat-select id="pageSize" [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChange($event)">
        <mat-option *ngFor="let option of pageSizeOptions" [value]="option">{{ option }}</mat-option>
      </mat-select>
    </div>
  </section> 

  <section class="table-panel">
    <div *ngIf="isLoading" class="table-loader">
      <app-loading size="0.5" color="var(--primary-sec-color)"></app-loading>
    </div>

    <div class="table-wrap" [class.table-wrap--empty]="!appointments.items.length" *ngIf="!isLoading">
      <table>
        <thead>
          <tr>
            <th>Created</th>
            <th>Scheduled</th>
            <th>Category</th>
            <th>Type</th>
            <th>Customer</th>
            <th>Vehicle</th>
            <th>Source</th>
            <th>Status</th>
            <th>RO #</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of appointments.items">
            <td>{{ row.createdAt }}</td>
            <td>{{ row.scheduledAt }}</td>
            <td>
              <span class="badge-cat" [ngClass]="{
                'badge-service': row.category === 'Service',
                'badge-sales': row.category === 'Sales',
                'badge-parts': row.category === 'Parts'
              }">{{ row.category }}</span>
            </td>
            <td>{{ row.type }}</td>
            <td>{{ row.customerName }}</td>
            <td>{{ row.vehicle }}</td>
            <td>{{ row.source === 'ASP' ? 'Customer' : row.source === 'ASPBDC' ? 'Dealer' : row.source }}</td>
            <td>{{ row.status }}</td>
            <td>{{ row.roNumber || '-' }}</td>
          </tr>
          <tr *ngIf="!appointments.items.length && !isLoading">
            <td colspan="9" class="empty">No appointments found for selected filters.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <mat-paginator
      *ngIf="appointments.totalCount > 0"
      [length]="appointments.totalCount"
      [pageIndex]="pageIndex"
      [pageSize]="pageSize"
      [pageSizeOptions]="[pageSize]"
      hidePageSize="true"
      showFirstLastButtons
      (page)="onPageChange($event)">
    </mat-paginator>
  </section>
</section>
